import { createFileRoute } from '@tanstack/react-router';

import {
  BlogPostEditPage,
  blogCategoriesQueryOptions,
  blogPostQueryOptions,
} from '@/features/blog';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/blog/$postId')({
  staticData: { tours: ['content.blog-post'] },
  loader: async ({ context, params }) => {
    const [post] = await Promise.all([
      context.queryClient.query({
        ...blogPostQueryOptions(params.storeId, params.postId),
        staleTime: 'static',
      }),
      context.queryClient
        .query({ ...blogCategoriesQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
    ]);
    return { crumb: post.title };
  },
  component: BlogPostEditPage,
});
